import React from 'react'
import { observer } from 'mobx-react-lite'

import {
  EmptyState,
  Loader,
  MiniWidgetContainer,
  useGlobalCopyStore,
  useGlobalUiStore,
  useRecurringTransactionsStore,
  useWidgetLoadTimer,
} from '../common'
import { MiniWidgetProps } from '../core'

import CashflowWidgetContent from './components/CashflowWidgetContent'
import { useCashflowUiStore } from './context/hooks'

const CashflowMiniWidget: React.FC<MiniWidgetProps> = ({
  onPrimaryCtaClick,
  onSecondaryCtaClick,
  sx = {},
}) => {
  const { cashflow: copy } = useGlobalCopyStore()
  const { isInitialized } = useGlobalUiStore()
  const { income } = useCashflowUiStore()
  const { loadRepeatingTransactionData, isDataLoaded } = useRecurringTransactionsStore()

  React.useEffect(() => {
    if (!isDataLoaded) {
      loadRepeatingTransactionData().finally()
    }
  }, [])

  useWidgetLoadTimer({
    widgetName: 'CashflowMiniWidget',
    isLoaded: isDataLoaded,
  })

  const showEmptyState = isDataLoaded && !income.length

  if (!isInitialized) return <Loader />

  return (
    <MiniWidgetContainer
      className="mx-exp-cashflow-miniwidget"
      onPrimaryCtaClick={onPrimaryCtaClick}
      primaryCtaLabel={copy.primary_cta}
      primaryCtaLabelAria={copy.primary_cta_aria}
      subTitle={showEmptyState || !isDataLoaded ? undefined : copy.sub_title}
      sx={{ height: '100%', ...sx }}
      title={copy.title}
    >
      {!isDataLoaded && <Loader />}
      {isDataLoaded &&
        (showEmptyState ? (
          <EmptyState
            header={copy.create}
            icon="local_atm"
            onClick={onSecondaryCtaClick}
            primaryButton={copy.add_income}
            primaryButtonStartIcon="add"
            subText={copy.create_description}
          />
        ) : (
          <CashflowWidgetContent />
        ))}
    </MiniWidgetContainer>
  )
}

export default observer(CashflowMiniWidget)
